import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { IWebConfig } from 'src/app/shared/model/IWebConfig';
import { WebConfigService } from 'src/app/shared/services/web-config/web-config.service';
@Component({
  selector: 'app-downtime',
  imports: [CommonModule, TranslatePipe, RouterModule],
  templateUrl: './downtime.component.html',
  styleUrls: ['./downtime.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

  standalone: true,
})
export class DowntimeComponent implements OnInit {
  webconfig: IWebConfig = inject(WebConfigService);
  public backgroundImage;
  public link = { submit: '/downtime/submit-request', contact: '/downtime/contact-us' };
  ngOnInit(): void {
    this.backgroundImage = this.webconfig.assets.authScreenBackground;
  }
}
